import { Box, CircularProgress, Divider } from "@mui/material";
import { BasicPageContainer } from "components/views/BasicPageContainer";
import { HeaderSection } from "components/views/myTrainings/HeaderSection/HeaderSection";
import { YourStatisticsSection } from "components/views/myTrainings/YourStatisticsSection/YourStatisticsSection";
import { YourLessonsSection } from "components/views/myTrainings/YourLessonsSection/YourLessonsSection";
import { useContext, useEffect } from "react";
import { MyTrainingsViewContext } from "context/myTrainings/MyTrainingsViewContext";
import { MyTrainingsViewContextProvider } from "context/myTrainings/MyTrainingsViewContextProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutePaths } from "constants/RoutePaths";
import { useAuthContext } from "hooks/useAuthContext";

const MyTrainingsPageContent = () => {
    const { user, trainingStatistics, getStatisticsPending, isStatisticOfLoggedUser } = useContext(MyTrainingsViewContext);
    const { userState } = useAuthContext();
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('userId');

    useEffect(() => {
        if (userState?.user?.userId && userId && userState.user.userId === userId) {
            navigate(RoutePaths.HOME);
        }
    }, [userState?.user.userId, userId, navigate]);

    return !user
    ? <CircularProgress/>
    : <BasicPageContainer>
        <HeaderSection/>
        <Divider />
        {getStatisticsPending 
            ? <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
              </Box>
            : trainingStatistics && <YourStatisticsSection statistics={trainingStatistics} getStatisticsPending={getStatisticsPending} isStatisticOfLoggedUser={isStatisticOfLoggedUser}/>
        }
        <Divider />

        {trainingStatistics && <YourLessonsSection allProgresses={trainingStatistics.allProgresses} actualProgresses={trainingStatistics.actualProgresses} lessons={trainingStatistics.lessons} isStatisticOfLoggedUser={isStatisticOfLoggedUser} />}
    </BasicPageContainer>
}

export const MyTrainingsPage = () => {
    return <MyTrainingsViewContextProvider>
        <MyTrainingsPageContent/>
    </MyTrainingsViewContextProvider>
}